// Interface to define over merged SkyClickPlayer + Video.JS object
import SkyClickPlayer, {SkyClickPlayerEventType, SkyClickPlayerHookType} from "../../components/custom/SkyClickPlayer";
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";

class CustomPlugin<T = any>{

    static readonly PLUGIN_NAME:string;

    // Should plugin startup automatically
    static autoStart:boolean = false;

    static bootingStaticApi(){
        // register plugin
        let pluginClass = this; //class reference to plugin class
        SkyClickPlayer.vjs.plugin(this.PLUGIN_NAME,function(options:any){
            let playerInstance = this; // plugin function has as context the player instance
            // overwrite plugin function constructor, with instantiated plugin instance in player instance
            playerInstance[pluginClass.PLUGIN_NAME] = new pluginClass(pluginClass.PLUGIN_NAME, playerInstance,options);
        });

        // add listener to define define a auto start for this plugin
        if(this.autoStart){
            let pluginName = this.PLUGIN_NAME;
            SkyClickPlayer.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl:Element, options: any) => {
                // make sure, that plugin options are defined, that this plugin auto start
                // (take existing plugins options or create empty object as default)
                options.plugins[pluginName] =  options.plugins[pluginName] || {};
                return options;
            });
        }
    }

    /**
     * Constructor of plugin - will be constructed when videojs startup the plugin
     * @param pluginName
     * @param skyClickPlayer
     * @param options
     */
    constructor(public pluginName:string, public skyClickPlayer:SkyClickPlayer, public options:T){
        this.init();

        // Register for each plugin a player-ready-handler
        this.skyClickPlayer.eventManager.addListener<SkyClickPlayerEventType>('READY_FOR_SYSTEM_PLUGINS',this.onPlayerReady.bind(this));

    }

    init(){}

    // At this moment, we can add e.g. components to the player,
    // because custom components depend sometimes from other default components.
    // Because the default components are added after the auto start of our plugins.
    // So we have to wait for the ready event, then we know every default component is certainly added
    protected onPlayerReady(){}

}

export default CustomPlugin;


// WEBPACK FOOTER //
// ./src/app/plugins/custom/CustomPlugin.ts